export var getParameterByName = function (name, w) {
    var processedName = name.replace(/[\[\]]/g, '\\$&');
    var url = w.location.href;
    var regex = new RegExp('[?&]' + processedName + '(=([^&#]*)|&|#|$)');
    var results = regex.exec(url);
    if (!results || !results[2]) {
        return undefined;
    }
    else {
        return decodeURIComponent(results[2].replace(/\+/g, ' '));
    }
};
export var getNamespacedFeatureKey = function (key) { return "__aex_" + key; };
export var safelyAccessLocalStorage = function (item) {
    try {
        return localStorage && localStorage.getItem(item);
    }
    catch (e) {
        return null;
    }
};
//# sourceMappingURL=utils.js.map